import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {HttpClientModule} from '@angular/common/http';
import {RippleModule} from 'primeng/ripple';
import {ToastModule} from 'primeng/toast';
import {ConfirmationService, MessageService} from 'primeng/api';
import {ButtonModule} from 'primeng/button';
import {MenuModule} from 'primeng/menu';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MessagesModule} from 'primeng/messages';
import {DialogModule} from 'primeng/dialog';
import {SelectButtonModule} from 'primeng/selectbutton';
import {DropdownModule} from 'primeng/dropdown';
import {MultiSelectModule} from 'primeng/multiselect';
import {CalendarModule} from 'primeng/calendar';
import {DividerModule} from 'primeng/divider';
import {FieldsetModule} from 'primeng/fieldset';
import {TabViewModule} from 'primeng/tabview';
import {PdfViewerWidgetComponent} from './widgets/pdf-viewer-widget/pdf-viewer-widget.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {NgxExtendedPdfViewerServerModule} from 'ngx-extended-pdf-viewer';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import { InvoicesStatementsFilterWidgetComponent } from './widgets/invoices-statements-filter-widget/invoices-statements-filter-widget.component';

@NgModule({
    declarations: [PdfViewerWidgetComponent, InvoicesStatementsFilterWidgetComponent],
    imports: [
        PdfViewerModule,
        CommonModule,
        ProgressSpinnerModule,
        HttpClientModule,
        RippleModule,
        ToastModule,
        ButtonModule,
        MenuModule,
        ReactiveFormsModule,
        InputTextModule,
        ConfirmDialogModule,
        MessagesModule,
        FormsModule,
        DialogModule,
        SelectButtonModule,
        DropdownModule,
        MultiSelectModule,
        CalendarModule,
        DividerModule,
        FieldsetModule,
        TabViewModule,
        PdfViewerModule,
        NgxExtendedPdfViewerServerModule,
        BreadcrumbModule,
    ],
    exports: [PdfViewerWidgetComponent, InvoicesStatementsFilterWidgetComponent],
    providers: [MessageService, ConfirmationService]
})
export class SharedModule {

}
